import { ComponentWithPermissions } from '../../../../../../baseComponents/CreateRoutering/types'
import { permissionCheck } from '../../../../../../baseComponents/PermissionChecker/function'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'
import { GroupVatPayload } from '../../../../../../utils/reducers/globals/groupVats'
import { connect, ConnectedProps } from 'react-redux'
import { AllReduxPayloads } from '../../../../../../utils/reducers'
import withLoading from '../../../../../../utils/hoc/withLoading'
import ModalCECostSell from './ModalCECostSell'
import { CostSellModelType } from '@teinor/erp/types/company/config/cost/costSell'
import TwinTable from '../../../../../../baseComponents/TwinTable'
import BaseScreenTable from '../../../../../../baseComponents/TwinTable/BaseScreenTable'
import { TableComponentProps } from '../../../../../../baseComponents/TwinTable/BaseScreenTable/types'
import { CustomRenderString, EditRow, DeleteRow } from '../../../../../../baseComponents/TwinTable/VirtualTableListing/CustomRenders'
import { ColumnTableSchema } from '../../../../../../baseComponents/TwinTable/VirtualTableListing/Subcomponents/types'
import ModalDeleteCostSell from './ModalDeleteCostSell'

interface ConfigCostSellsProps extends ComponentWithPermissions {}

const ConfigCostSells: React.FC<ConfigCostSellsProps> = ({ userPermissions }) => {
    const { t } = useTwinTranslation()

    const pageData = {
        title: t('costSells', 'Costes de venta'),
        newText: t('newCost', 'Nuevo coste'),
    }

    return (
        <BaseScreenTable TableComponent={TableCostSellsConnect} CreateModalComponent={ModalCECostSell} EditModalComponent={ModalCECostSell} DeleteModalComponent={ModalDeleteCostSell} pageData={pageData} userPermissions={userPermissions} />
    )
}

type TableCostSellsProps = TableComponentProps & ReduxConfigCostSells & {}

const TableCostSells: React.FC<TableCostSellsProps> = ({ userPermissions, setTableInstance, setOpened, groupVats }) => {
    const { t } = useTwinTranslation()

    const columns: ColumnTableSchema<CostSellModelType> = [
        {
            id: 'id',
            dataKey: 'id',
            label: t('id', 'ID'),
            sortable: true,
        },
        {
            id: 'name',
            dataKey: 'name',
            label: t('name', 'Nombre'),
            searchableComponent: {
                component: 'SearchableComponentBasic',
                extraComponentData: { label: t('name', 'Nombre') }
            }
        },
        {
            id: 'GroupVatId',
            dataKey: 'GroupVatId',
            label: t('groupVat', 'Grupo de impuestos'),
            customRender: (parameterValue) => <CustomRenderString value={String(groupVats?.[parameterValue]?.name || '')} />,
            generalSearchable: false
        },
        {
            id: 'edit',
            dataKey: 'id',
            label: '',
            width: 50,
            simpleLabel: t('edit', 'Editar'),
            customRender: (parameterValue, allRowData) => <EditRow key={'edit' + parameterValue} {...{ parameterValue, allRowData }} onClick={(_idk, allRowData) => setOpened({ type: 'edit', allRowData })} />,
            havePermission: permissionCheck(userPermissions, 'update')
        },
        {
            id: 'delete',
            dataKey: 'id',
            label: '',
            width: 50,
            simpleLabel: t('delete', 'Eliminar'),
            customRender: (parameterValue, allRowData) => <DeleteRow key={'delete' + parameterValue} {...{ parameterValue, allRowData }} onClick={(_idk, allRowData) => setOpened({ type: 'delete', allRowData })} />,
            havePermission: permissionCheck(userPermissions, 'delete')
        }
    ]
    return (
        <TwinTable name='costSells' columns={columns} getDataFrom='/api/app/config/cost/costSell/getAllCostSells' setTableInstance={setTableInstance} onRowClick={(_id, rowData) => setOpened({ type: 'edit', allRowData: rowData })} extraWhereParams={{active: true}} />
    )
}

const configCostSellsDispatch = {
    setGroupVats: (payload: GroupVatPayload) => ({ type: 'CHANGE_GROUPVAT', payload }),
}

export type ReduxConfigCostSells = ConnectedProps<typeof configCostSellsConnect>
const mapConfigCostSellsConnector = (state: AllReduxPayloads) => ({ groupVats: state.groupVats })
const configCostSellsConnect = connect(mapConfigCostSellsConnector, configCostSellsDispatch)

const configCostSellsConnectLoading = withLoading(TableCostSells, [{ fetchUrl: '/api/app/config/vat/getAllGroupsVat', propName: 'groupVats', setFunctionName: 'setGroupVats' }])

const TableCostSellsConnect = configCostSellsConnect(configCostSellsConnectLoading)

export default ConfigCostSells